import { z } from 'zod';
export const pauseReasonCategorySchema = z.enum([
    'missing_repository_signal',
    'ambiguous_repository_candidates',
    'partial_repository_coverage',
    'policy_requires_confirmation',
]);
export const classificationBandSchema = z.enum(['high', 'needs_confirmation']);
export const repositoryScopeHandoffStatusSchema = z.enum(['awaiting_intake']);
/**
 * Subset of `git check-ref-format --branch` sufficient to keep a branch name from being
 * parsed as a `git` option or refspec when it reaches checkout argv (DC-486).
 */
export function isValidGitBranchName(name) {
    if (name.length === 0 || name.length > 255)
        return false;
    if (name.startsWith('-') || name.startsWith('/') || name.startsWith('.'))
        return false;
    if (name.endsWith('/') || name.endsWith('.') || name.endsWith('.lock'))
        return false;
    if (name === '@')
        return false;
    if (name.includes('..') || name.includes('//') || name.includes('@{'))
        return false;
    // eslint-disable-next-line no-control-regex
    return !/[\u0000-\u0020\u007f~^:?*[\\]/.test(name);
}
export const gitBranchNameSchema = z
    .string()
    .refine(isValidGitBranchName, { message: 'Invalid Git branch name' });
/** Per-repository Git branch chosen at scope confirmation (DC-486). */
export const selectedBranchesMapSchema = z.record(z.string().uuid(), gitBranchNameSchema);
export const repositoryScopeHandoffResponseSchema = z.object({
    organization_id: z.string().uuid(),
    work_item_id: z.string().uuid(),
    correlation_id: z.string().uuid(),
    policy_rule_version_fingerprint: z.string().max(128),
    classification_band: classificationBandSchema,
    pause_reason_category: pauseReasonCategorySchema.nullable(),
    paused_for_confirmation: z.boolean(),
    suggested_repository_ids: z.array(z.string().uuid()),
    authoritative_repository_ids: z.array(z.string().uuid()),
    selected_branches: selectedBranchesMapSchema.optional(),
    confirmation: z
        .object({
        confirmed_at: z.string().datetime(),
        confirmed_by_user_id: z.string().uuid(),
    })
        .nullable(),
    updated_at: z.string().datetime(),
    handoff_status: repositoryScopeHandoffStatusSchema.optional(),
});
export const repositoryScopeConfirmRequestSchema = z.object({
    authoritative_repository_ids: z.array(z.string().uuid()).min(1),
    expected_handoff_updated_at: z.string().datetime(),
    expected_policy_version: z.string().optional(),
    selected_branches: selectedBranchesMapSchema.optional(),
});
/** PATCH …/repository-scope/selected-branches — branch-only edit after confirm. */
export const repositoryScopeBranchChangeRequestSchema = z.object({
    expected_handoff_updated_at: z.string().datetime(),
    selected_branches: selectedBranchesMapSchema.optional(),
});
export const repositoryScopeConfirmIntakeResumeSchema = z.object({
    status: z.enum(['accepted', 'rejected', 'skipped', 'failed']),
    outcome: z.string().optional(),
    reason_code: z.string().nullable().optional(),
    skip_reason: z.string().optional(),
    generation_attempt_id: z.string().uuid().nullable().optional(),
});
/** POST …/repository-scope success body (handoff row + optional intake resume summary). */
export const repositoryScopeConfirmResponseSchema = repositoryScopeHandoffResponseSchema.extend({
    intake_resume: repositoryScopeConfirmIntakeResumeSchema.optional(),
});
//# sourceMappingURL=repository-scope-handoff.js.map